<template>
  <!-- //LANGUAGE ITEM DROPDOWN
        <b-nav-item-dropdown right class="lang pr-0">
            <template slot="button-content">
                <b-img :src="selectedLang.icon" alt=""/>
            </template>
            <b-dropdown-item v-for="entry in languages" 
                :key="entry.title" @click="changeLocale(entry)" > 
                <b-img :src="entry.icon" alt="" /><span> {{entry.language}} </span></b-dropdown-item>  
        </b-nav-item-dropdown>
      -->
    <div>

  <v-app-bar app dark color="primary" height="72" id="header" class="header-container">
    <v-app-bar-nav-icon v-if="windowWidth <= sm" v-model="drawer" @click="drawer = !drawer"></v-app-bar-nav-icon>
    <v-toolbar-title class="ml-3" v-bind:class="{ 'toolbar-title': $route.meta.title !== 'sidebar-org-select' }">
      {{ $t($route.meta.title) }}
      <v-tooltip right v-if="helpUrl" open-delay="150">
        <template #activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            class="help-icon"
            :aria-label="helpTooltip || 'Help'"
            @click="$emit('help-click', helpUrl)"
          >
            <v-icon small>mdi-help-circle-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ helpTooltip || 'Help' }}</span>
      </v-tooltip>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <notification-center v-if="windowWidth > sm" class="mr-2" />
    <v-col
      v-show="$route.meta.headerSites"
      class="header-dropdown"
      id="site-select"
      cols="12"
      sm="3"
    >
      <v-autocomplete
        id="selectSite"
        :items="sites"
        item-text="value"
        item-value="id"
        v-on:change="onSiteChange"
        label="Site"
        v-model="selectedSide"
        :no-data-text="$t('sites-not-available')"
        outlined
        dense
      >
       <template v-slot:item="data">
          <template>
            <v-list-item-content v-text="data.item.value"></v-list-item-content>
          </template>
        </template>
      </v-autocomplete>
    </v-col>
    </v-app-bar>

    <!-- mobile version sidebar -->
    <v-navigation-drawer v-if="windowWidth <= sm" v-model="drawer" app class="primary nav-drawer">
      <!-- Level 1: parents -->
      <v-list v-if="!activeParent">
        <v-list-item
          v-for="itemLink in sidebarLinks"
          :key="itemLink.title"
          @click="handleParentClick(itemLink)"
          v-show="(itemLink.title !== 'sidebar-org-select' || (itemLink.title === 'sidebar-org-select' && organizations.length > 1))
                  && itemLink.visible
                  && ((!currentSite.isAf3) || (currentSite.isAf3 && !itemLink.hideForAf3))
                  && (itemLink.condition ? evalCondition(itemLink) : true)"
        >
          <v-list-item-action>
            <v-icon class="white--text link-icon" v-text="itemLink.icon" medium></v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{ $t(itemLink.title) }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="itemLink.subMenuItems && itemLink.subMenuItems.length">
            <v-icon class="white--text" small>mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <!-- Level 2: children of active parent -->
      <v-list v-else>
        <v-list-item @click="backToParents">
          <v-list-item-action>
            <v-icon class="white--text" small>mdi-chevron-left</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{ $t(activeParent.title) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-for="submenuItem in activeParent.subMenuItems"
          :key="submenuItem.title || submenuItem.name"
          v-show="(submenuItem.condition ? evalCondition(submenuItem) : true)
                  && ((!currentSite.isAf3) || (currentSite.isAf3 && !submenuItem.hideForAf3))"
          @click="onNavigate(submenuItem)"
        >
          <v-list-item-content>
            <v-list-item-title class="white--text">
              {{ submenuItem.string_name ? submenuItem.string_name : $t(submenuItem.name) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- Bottom actions: Change Password + Log Out -->
      <v-list>
        <v-list-item
          v-for="logoutItem in logoutItems"
          :key="logoutItem.title"
          @click.stop="handleLogoutAction(logoutItem.action, logoutItem.toLink)"
        >
          <v-list-item-action>
            <v-icon class="white--text" v-text="logoutItem.icon" medium></v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{ $t(logoutItem.title) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <confirm-modal
      @confirm="logout"
      @cancel="confirmationModal = false"
      :dialogModel="confirmationModal"
      :dialogTitle="$t('sidebar-logout')"
      :dialogBody="$t('logout-are-you-sure')"
    />
    <confirm-modal
      @confirm="resetPassword"
      @cancel="resetPasswordModal = false"
      :dialogModel="resetPasswordModal"
      :dialogTitle="$t('reset-password')"
      :dialogBody="$t('reset-password-are-you-sure')"
    />
    <confirm-modal
      @confirm="noItemsModal = false"
      dialogConfirmOnly="true"
      :dialogModel="noItemsModal"
      :dialogBody="modalMsg"
      :dialogConfirmBtn="$t('ok')"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import i18n from '../../i18n.js';
import confirmModal from '../../components/shared/modals/confirmModal'
import NotificationCenter from '../../components/notifications/notification-center.vue'
import sidebarJson from "../../assets/data/sidebar";
import resolutionConstants from '../../constants/resolutions-constants'

export default {
  data() {
    return {
      languages: [
        {
          title: 'English',
          language: 'en',
          icon: '../../../src/assets/img/flags/us-flag.png',
        },
        {
          title: 'Español',
          language: 'es',
          icon: '../../../src/assets/img/flags/spain-flag.png',
        },
      ],
      selectedLang: [
        {
          title: 'English',
          language: 'en',
          icon: '../../../src/assets/img/flags/us-flag.png',
        },
      ],
      sidebarLinks: sidebarJson.sidebarMenu,
      logoutItems: sidebarJson.LogoutSidebarMenu,
      activeParent: null,
      selectedSide: null,
      drawer: false,
      confirmationModal: false,
      resetPasswordModal: false,
      sm: resolutionConstants.IPAD_PORTRAIT,
      noItemsModal: false,
      modalMsg: null
    };
  },
  props: {
    windowWidth: Number,
    helpUrl: { type: String, default: null },
    helpTooltip: { type: String, default: '' },
  },
  components: {
    confirmModal,
    NotificationCenter
  },
  computed: {
    ...mapGetters('site', ['sites', 'currentSite', 'currentSiteId']),
    ...mapGetters('organization', ['organizations', 'currentOrganization', 'orgRoles']),
    ...mapGetters('header', ['getMapVisible']),
    ...mapGetters('layout', ['getWindowWidth', 'getIsMobileIpadPortrait']),
  },
  methods: {
    ...mapActions('site', ['setCurrentSiteId', 'getSiteUserRole']),
    ...mapActions('notification', ['fetchActiveNotifications']),
    ...mapMutations('tableau', ['clearWorkbooks']),
    handleLogoutAction(action, toLink) {
      if (toLink) {
        this.onNavigate({ toLink });
        return;
      }
      if (action === 'logout') {
        this.confirmationModal = true;
      } else if (action === 'resetPassword') {
        this.resetPasswordModal = true;
      }
    },
    evalCondition(item){
      let result = true;
      if(Array.isArray(item.condition)){
        item.condition.forEach(condition => {
          if (condition.operand && condition.operand === 'or') {
            result =
              result ||
              (!!this[condition.getter] && this[condition.getter] !== undefined
                ? this[condition.getter][condition.property] === condition.value
                : false);
          } else {
            result =
              result &&
              (!!this[condition.getter] && this[condition.getter] !== undefined
                ? this[condition.getter][condition.property] === condition.value
                : false);
          }
        });
        if(result && item.loadSubMenu && (item.subMenuItems[0] && (Object.keys(item.subMenuItems[0]).length === 0))){
          this.loadSubmenu(item);
        }
      }else{
        if(item.subMenuItems){
          result = false;
          item.subMenuItems.forEach(subItem => {
            result = result || this.evalCondition(subItem);
          });
        }
      }
      return result; 
    },
    async loadSubmenu(item){
      let submenu = await this.$store.dispatch(item.loadSubMenu);
      item.subMenuItems =  submenu;
      this.$store.commit(item.setSubMenu, submenu);
    },
    changeLocale(locale) {
      i18n.locale = locale.language;
      this.selectedLang.title = locale.title;
      this.selectedLang.language = locale.language;
      this.selectedLang.icon = locale.icon;
    },
    handleParentClick(item) {
      if (item.subMenuItems && item.subMenuItems.length) {
        this.activeParent = item;
      } else {
        this.onNavigate(item);
      }
    },
    backToParents() {
      this.activeParent = null;
    },
    onNavigate(link) {
      if(link.param){
        (this.$router.currentRoute.name !== link.toLink || JSON.stringify(this.$router.currentRoute.params) !== JSON.stringify(link.param) ) ? this.$router.push({name: link.toLink, params: link.param}) : null;
      }
      else{
        if(link.toLink){
          this.$router.currentRoute.path !== link.toLink ? this.$router.push(link.toLink) : null;
        }
      }
      if(link.loadSubMenu && link.subMenuItems.length === 0){
          this.noItemsModal = true;
          this.modalMsg = this.$t(link.emptySubmenuInfo);
      }
      this.activeParent = null;
      this.drawer = false;
    },
    async onSiteChange(siteId) {
      if (siteId !== this.currentSiteId) {
        this.setCurrentSiteId({ siteId });
        this.sidebarLinks.map(link => {
          if (link.loadSubMenu) {
            this.$set(link, 'collapsed', true);
            link.subMenuItems = [{}];
            this.clearWorkbooks();
          }
        });
      }
    },
    setLinks() {
      // Show all links in both fullscreen and portable menu for consistency
      this.sidebarLinks.map((link) => {
        this.$set(link, 'visible', true)
      })
    },
    logout() {
      this.$store.dispatch('logout', {vuetify: this.$vuetify});
    },
    async resetPassword() {
      this.resetPasswordModal = false;
      try {
        const username = this.$store.getters.getUsername;
        await this.$store.dispatch('forgot', { username });
        this.$toasted.show(this.$i18n.t('forgot-sent'), {
          position: 'bottom-right',
          className: ['toast-success'],
          duration: 1500,
        });
      } catch (error) {
        this.$toasted.show(error, {
          position: 'bottom-right',
          className: ['toast-error'],
          duration: 1500,
        });
      }
    }
  },
  created() {
    this.selectedSide = this.currentSite;
    this.selectedLang.icon = '../../../src/assets/img/flags/us-flag.png';
    if (this.$route.meta.menuItems) {
      this.sidebarLinks = sidebarJson[this.$route.meta.menuItems];
    }
    this.setLinks();
  },
  mounted() {
    this.fetchActiveNotifications().catch(err => {
      console.error('Failed to fetch initial active notifications:', err);
    });
  },
  watch: {
    getIsMobileIpadPortrait: function () {
      this.setLinks();
    },
    currentSite: async function (site, oldSite) {
      if(site.id){
        this.selectedSide = site;
        if (!localStorage.getItem('orgId')) {
          await this.getSiteUserRole(site.id);
        }
      }
    },
    $route(to, from) {
      if(to.meta.menuItems !== from.meta.menuItems){
        this.$set(this, 'sidebarLinks', sidebarJson[to.meta.menuItems]);
        this.setLinks();
      }
      this.activeParent = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.link-icon {
  position: absolute !important;
  top: 12px;
}
.nav-drawer {
  .v-navigation-drawer__content{
    max-height: 85%;
  }
}
.v-btn-toggle > .v-btn.v-btn {
  opacity: 1 !important;
}
.header-dropdown {
  margin-top: 30px;
  min-width: 250px;
}
@media (max-width: 768px) {
  .header-dropdown {
    max-width: 70vw;
    padding: 5px;
    margin-right: 2px;
  }
}
.mobile-submenu {
  padding: 10px 5px 10px 10px;
  text-transform: capitalize;
}
.help-icon {
  margin-left: -12px !important;
  margin-top: -6px;
  color: white;
  transition: color 0.2s, transform 0.2s;
}
.help-icon:hover {
  color: #fff;
  transform: scale(1.05);
}

::v-deep(.v-tooltip__content) {
  margin-left: 4px; // empuja el tooltip un poquito a la derecha
}
</style>